import { Component, Signal, computed, input } from '@angular/core';

import { Transaction } from '@ap/fido-uaf-frontend-client';
import { ContentTypeId } from '@ap/interface-apic-authenticatie-fido';
import { ApAccordionComponent } from '@ap/accordion';
import { ApAccordionItemComponent } from '@ap/accordion';
import { ApKeyValueComponent } from '@ap/key-value';
import { ApKeyComponent } from '@ap/key-value';
import { ApValueComponent } from '@ap/key-value';

import { ApTokenService } from '../token/token.service';

import { SignSummaryItem } from './wysiwys.model';

/**
 * @ngdoc component
 * @name ApWysiwysComponent
 */
@Component({
    selector: 'ap-wysiwys',
    standalone: true,
    templateUrl: './wysiwys.component.html',
    imports: [ApAccordionComponent, ApAccordionItemComponent, ApKeyValueComponent, ApKeyComponent, ApValueComponent]
})
export class ApWysiwysComponent {
    /**
     * Required - Transactions to display
     */
    public readonly transactions = input.required<Transaction[]>();

    public signMessage: Signal<string> = computed(() => this.getSignMessage(this.transactions()));
    public signSummary: Signal<SignSummaryItem[]> = computed(() => this.getSignSummary(this.transactions()));

    public isSignSummaryEmpty(): boolean {
        const signSummary = this.signSummary();
        return signSummary == null || signSummary.length === 0;
    }

    private getEncodedText(transaction: Transaction[], contentType: ContentTypeId): string {
        const plainText = transaction && transaction.find((content) => content.contentType === contentType);
        return plainText && plainText.content;
    }

    private getSignMessage(transactions: Transaction[]): string {
        const message = this.getEncodedText(transactions, ContentTypeId.TEXT_PLAIN);
        return ApTokenService.decodeEncodedText(message);
    }

    private getSignSummary(transactions: Transaction[]): SignSummaryItem[] {
        const summary = this.getEncodedText(transactions, ContentTypeId.VND_DEVOLKSBANK_AUTHREQUEST_JSON);
        return summary ? JSON.parse(ApTokenService.decodeEncodedText(summary)).items : [];
    }
}
